import React from 'react';
import { Box, Flex, Spinner, Text, useColorModeValue } from '@chakra-ui/react';

function Loading() {
  const bgColor = useColorModeValue('white', 'gray.800'); // light or dark background based on mode
  const textColor = useColorModeValue('gray.700', 'white'); // text color for dark and light modes

  return (
    <Flex
      align="center"
      justify="center"
      minH="100vh"
      bg={bgColor}
      px={4}
      direction="column"
    >
      <Box
        bg="white"
        p={8}
        rounded="2xl"
        shadow="lg"
        textAlign="center"
        maxW="md"
        w="full"
      >
        {/* Loading Spinner */}
        <Spinner size="xl" color="#007AFF" thickness="4px" speed="0.8s" />

        <Text mt={4} fontSize="lg" fontWeight="semibold" color={textColor}>
          Please wait, loading dashboard...
        </Text>
      </Box>
    </Flex>
  );
}

export default Loading;
